import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import AddPayoutContainer from './AddPayoutContainer';
import messages from '../../locale/jsonMessages';

export default async function action({ store, intl }) {
  const title = intl?.formatMessage(messages.addPayoutPreferencesTabTitle);

  // From Redux Store
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    return { redirect: '/login' };
  }

  let accountData = store.getState().account.data;

  return {
    title,
    component: <UserLayout showSideMenu={'accountMenu'}><AddPayoutContainer title={title} initialData={accountData} /></UserLayout>,
  };

};
